import React, { useMemo, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { uniqueId } from 'lodash-es';
import { setSelectedLanguage } from '#/user/slice';
import { LANGUAGE_OPTIONS } from '#/shared/constants';
import { ScreenReaderText } from '#/shared/components/Accessibility';
import * as Styled from './styled';

function TranslateListButton() {
  const { alertBannerIsVisible, mobileMode, selectedLocale } = useSelector(
    s => s.user
  );

  const dispatch = useDispatch();
  const intl = useIntl();

  const languageOptions = useMemo(
    () =>
      LANGUAGE_OPTIONS.map(lang => ({
        ...lang,
        value: lang.symbol,
        isDisabled: lang.symbol === selectedLocale,
        label: lang.displayName,
      })),
    [selectedLocale]
  );

  const onLanguageChange = ({ symbol: langSymbol }) => {
    const { smartlingTranslationAvailable } = LANGUAGE_OPTIONS.find(
      option => option.symbol === langSymbol
    );

    if (smartlingTranslationAvailable) {
      dispatch(setSelectedLanguage(langSymbol));
    } else {
      window.location.href = `https://trimet.org/${langSymbol}/index.htm`;
    }
  };

  const languageSelectLabelElementId = useRef(
    uniqueId('language-select-label-')
  ).current;

  const languageSelectValue = {
    value: '',
    label: (
      <Styled.LanguageButtonInnerWrapper>
        <Styled.LanguageButtonIcon aria-hidden />
        <ScreenReaderText
          visible={!mobileMode}
          id={languageSelectLabelElementId}
        >
          <FormattedMessage id="language-picker.language" />
        </ScreenReaderText>
      </Styled.LanguageButtonInnerWrapper>
    ),
  };

  const ariaLiveMessages = {
    onFocus: option => {
      const { focused, isDisabled } = option;
      return intl.formatMessage(
        {
          id: `language-picker.${
            isDisabled ? 'currently-selected' : 'focused-on'
          }`,
        },
        { language: focused.name }
      );
    },
  };

  // TODO: Follow up on https://github.com/JedWatson/react-select/pull/4080 to
  //  stop 1st element autofocus
  return (
    <Styled.LanguageButtonWrapper>
      <Styled.LanguageSelect
        ariaLiveMessages={ariaLiveMessages}
        components={Styled.CustomOption}
        mobileMode={mobileMode}
        ariaLabelledBy={languageSelectLabelElementId}
        id="language-select"
        inputId="language-select"
        value={languageSelectValue}
        name="languageSelect"
        options={languageOptions}
        classNamePrefix="language"
        onChange={onLanguageChange}
        alertBannerIsVisible={alertBannerIsVisible}
      />
    </Styled.LanguageButtonWrapper>
  );
}

export default TranslateListButton;
